import React from "react";
import { 
  Card,
  CardContent,
  Checkbox,
  Container, 
  Box, 
  Button,
  IconButton,
  Fab,
  Grid,
  Typography, 
  Tooltip,
  Icon, 
} from "@material-ui/core"
import Util from "../../common/Util"
class GridTotal extends React.PureComponent{
  constructor(props){
    super(props)
  }

  render(){
    const { theme, item, isTaxes } = this.props
    return (
      <Card variant="outlined" style={{backgroundColor:"#fafafa"}}>
        <CardContent>
          {/* <Grid xs={6}> */}
            <Grid container spacing={3} >  
              <Grid item xs={3} style={theme.gridTotal.header}>
                <Typography style={{fontWeight:"bold", fontSize:16}}>{isTaxes?"Comisiones":"Recaudaciones"}</Typography>
              </Grid>
              <Grid item xs={2} style={theme.gridTotal.header}>
                <Typography align="right">Mesa</Typography>
              </Grid>
              <Grid item xs={isTaxes?4:2} style={theme.gridTotal.header}>
                <Typography align="right">{isTaxes?"Delivery/TakeAway":"Delivery"}</Typography>
              </Grid>
              {isTaxes?null:
              <Grid item xs={2} style={theme.gridTotal.header}> 
                <Typography align="right">Take Away</Typography>
              </Grid>}
              <Grid item xs={2} style={{...theme.gridTotal.header,...theme.gridTotal.totalColumn}}> 
                <Typography align="right" style={theme.gridTotal.totalText}>Total</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}> 
              <Grid item xs={3} style={theme.gridTotal.titleColumn}> 
                <Typography>Efectivo</Typography> 
              </Grid>
              <Grid item xs={2} > 
                <Typography align="right">{Util.formatCurrency(item.ordTotalCashTable)}</Typography>
              </Grid>
              <Grid item xs={isTaxes?4:2}>  
                <Typography align="right">{Util.formatCurrency(isTaxes?item.ordTotalCashDeliveryTA:item.ordTotalCashDelivery)}</Typography>
              </Grid>
              {isTaxes?null:
              <Grid item xs={2}> 
                <Typography align="right">{Util.formatCurrency(item.ordTotalCashTakeAway)}</Typography>
              </Grid>}
              <Grid item xs={2}style={theme.gridTotal.totalColumn}> 
                <Typography align="right" style={theme.gridTotal.totalText}>{Util.formatCurrency(item.ordTotalCashTable+(isTaxes?item.ordTotalCashDeliveryTA:item.ordTotalCashDelivery+item.ordTotalCashTakeAway))}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}> 
              <Grid item xs={3} style={theme.gridTotal.titleColumn}> 
                <Typography>Tarjeta</Typography> 
              </Grid>
              <Grid item xs={2} > 
                <Typography align="right">{Util.formatCurrency(item.ordTotalCardTable)}</Typography>
              </Grid>
              <Grid item xs={isTaxes?4:2}>  
                <Typography align="right">{Util.formatCurrency(isTaxes?item.ordTotalCardDeliveryTA:item.ordTotalCardDelivery)}</Typography>
              </Grid>
              {isTaxes?null:
              <Grid item xs={2}> 
                <Typography align="right">{Util.formatCurrency(item.ordTotalCardTakeAway)}</Typography>
              </Grid>}
              <Grid item xs={2}style={theme.gridTotal.totalColumn}> 
                <Typography align="right" style={theme.gridTotal.totalText}>{Util.formatCurrency(item.ordTotalCardTable + (isTaxes?item.ordTotalCardDeliveryTA:(item.ordTotalCardDelivery+item.ordTotalCardTakeAway)))}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3} > 
              <Grid item xs={3} style={theme.gridTotal.totalRow}> 
                <Typography style={theme.gridTotal.totalText}>Total</Typography> 
              </Grid>
              <Grid item xs={2} style={theme.gridTotal.totalRow}> 
                <Typography align="right" style={theme.gridTotal.totalText}>{Util.formatCurrency(item.ordTotalCashTable + item.ordTotalCardTable)}</Typography>
              </Grid>
              <Grid item xs={isTaxes?4:2} style={theme.gridTotal.totalRow}> 
              <Typography align="right" style={theme.gridTotal.totalText}>{Util.formatCurrency(isTaxes?item.ordTotalCashDeliveryTA + item.ordTotalCardDeliveryTA:item.ordTotalCashDelivery + item.ordTotalCardDelivery)}</Typography>
              </Grid>
              {isTaxes?null:
              <Grid item xs={2} style={theme.gridTotal.totalRow}> 
                <Typography align="right" style={theme.gridTotal.totalText}>{Util.formatCurrency(item.ordTotalCashTakeAway + item.ordTotalCardTakeAway)}</Typography>
              </Grid>}
              <Grid item xs={2} style={{...theme.gridTotal.totalRow, ...theme.gridTotal.totalColumn}}>
                <Typography align="right" style={theme.gridTotal.totalText}>{
                  Util.formatCurrency(
                    item.ordTotalCashTable + item.ordTotalCardTable +
                    (isTaxes?item.ordTotalCashDeliveryTA + item.ordTotalCardDeliveryTA:
                      item.ordTotalCashDelivery + item.ordTotalCardDelivery + 
                      item.ordTotalCashTakeAway + item.ordTotalCardTakeAway
                    )
                  )
                }</Typography>
              </Grid>
            </Grid>
          {/* </Grid> */}
        </CardContent>
      </Card>
    )
  }
}

GridTotal.defaultProps = {
  item:  {
        ordTotalCashTable:500, ordTotalCardTable:600,
        ordTotalCashDelivery:300, ordTotalCardDelivery:200,
        ordTotalCashTakeAway:100, ordTotalCardTakeAway:700
      },
  isTaxes: false

}
export default GridTotal


// WEBPACK FOOTER //
// ./src/components/GridTotal/GridTotal.js